/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staples_ResultsInputs */

const en_staples_results = /** @type {(inputs: Staples_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredients`)
};

const de_staples_results = /** @type {(inputs: Staples_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten`)
};

/**
* | output |
* | --- |
* | "Ingredients" |
*
* @param {Staples_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const staples_results = /** @type {((inputs?: Staples_ResultsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staples_ResultsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_staples_results(inputs)
	return en_staples_results(inputs)
});